import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

// BİLEŞENLER
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';


import './ProductsPage.css'; 
import { useLanguage } from '../../context/LanguageContext';

const ProductsPage = () => {
  const [data, setData] = useState({ 
    categories: [], 
    catalogFeatures: [], 
    products: [] 
  });
  const [loading, setLoading] = useState(true);
  const { lang } = useLanguage();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catSnap, featSnap, prodSnap] = await Promise.all([
          getDocs(query(collection(db, "categories"), orderBy("order", "asc"))),
          getDocs(query(collection(db, "catalogFeatures"), orderBy("order", "asc"))),
          getDocs(collection(db, "products"))
        ]);
        
        setData({
          categories: catSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })),
          catalogFeatures: featSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })),
          products: prodSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        });
      } catch (error) {
        console.error("Firebase veri çekme hatası:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const t = (tr, en, ar) => {
    if (lang === 'AR') return ar;
    if (lang === 'EN') return en;
    return tr;
  };

  const getTranslatedContent = (item, type = 'title') => {
    if (!item) return ""; 
    if (lang === 'AR') return item[`${type}Ar`] || item[type] || "";
    if (lang === 'EN') return item[`${type}En`] || item[type] || "";
    return item[type] || "";
  };

  if (loading) return <div className="premium-loader">BIGMA</div>;

  return (
    <div className={`catalog-layout-wrapper ${lang === 'AR' ? 'rtl-mode' : ''}`}>
      <Navbar />
      

     
     

      <Footer />
    </div>
  );
};

export default ProductsPage;